import { defineMessages } from "react-intl";

export const messages = defineMessages({
  invoiceLandingLoadingTitle: {
    id: "invoice-ar.invoice-landing-loading-title",
    defaultMessage: "Loading...",
  },
  invoiceLandingLoadingMessage: {
    id: "invoice-ar.invoice-landing-loading-message",
    defaultMessage: "Your Invoice payment options will appear soon.",
  },

  invoiceNotFound: {
    id: "invoice-ar.invoice-not-found-error",
    defaultMessage: "Invoice not found",
  },
  invoiceUnexpectedError: {
    id: "invoice-ar.invoice-unexpected-error",
    defaultMessage:
      "An unexpected error occurred, please try again later or contact support",
  },
  invoiceIsPaidWithInvoiceNumber: {
    id: "invoice-ar.invoice-paid-with-invoice-number",
    defaultMessage: "Invoice {invoiceNumber} is paid",
  },

  invoicePaymentErrorInvoiceIsNotPayable: {
    id: "invoice-ar.invoice-payment-error-invoice-is-not-payable",
    defaultMessage: "Invoice is not payable",
  },
  invoicePaymentErrorInvoiceIsNotPayableWithInvoiceNumber: {
    id: "invoice-ar.invoice-payment-error-invoice-is-not-payable-with-invoice-number",
    defaultMessage: "Invoice {invoiceNumber} is not payable",
  },
  invoicePaymentErrorInvoiceIsNotPayableDescription: {
    id: "invoice-ar.invoice-payment-error-invoice-is-not-payable-description",
    defaultMessage:
      "Please contact your supplier for details on the status of this invoice.",
  },
  invoicePaymentErrorNoSupportedPaymentMethodsAvailable: {
    id: "invoice-ar.invoice-payment-error-no-supported-payment-methods-available",
    defaultMessage: "Online payment not supported",
  },
  invoicePaymentErrorNoSupportedPaymentMethodsAvailableDescription: {
    id: "invoice-ar.invoice-payment-error-no-supported-payment-methods-available-description",
    defaultMessage:
      "Online payment not supported for this invoice. Please pay the invoice via bank transfer.",
  },
});
